<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor link">&nbsp;Warehouse</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;Order List</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid mt-3">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                  <div class="d-flex mb-2 flex-wrap">
                    <div class="mr-2">
                      <button class="btn btn-primary mt-4" @click="toPage('/procure/create')"> Support Req </button>
                    </div>
                    <div style="width: 152px" class="mr-2">
                        Purpose
                        <multiselect v-model="searchSparepartType" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
                    </div>
                    <div style="width: 152px" class="mr-2">
                        Warehouse
                        <multiselect v-model="searchSparepartType" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
                    </div>
                    <div class="mr-2" style="width:152px">
                        All Status
                        <multiselect v-model="searchSparepartType" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
                    </div>
                    <div class="mr-2" style="width:166px;">
                        Date In From
                        <input type="date" name="" class="form-control text-field" placeholder="Product Name" v-model="searchSparepartName">
                    </div>
                    <div class="mr-2" style="width:166px">
                        Date In To
                        <input type="date" name="" class="form-control text-field" placeholder="Product Name" v-model="searchSparepartName">
                    </div>
                    <div>
                    <!-- <div class="col-lg-2 col-sm mobile-div"> -->
                        <button class="btn btn-primary mt-4 mr-2" @click="searchData"> Search </button>
                        <button class="btn btn-primary mt-4" @click="resetSearch"> Reset </button>
                    </div>
                  </div>
                <!-- </div> -->
                
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>Purpose</th>
                      <th>Identity ID</th>
                      <th>Allocation</th>
                      <th>Warehouse</th>
                      <th>Date In</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable === false && totalData == '0'">
                      <td colspan="11" class="text-center">Data Not Available</td>
                    </tr>
                    <tr v-else-if="loadingTable === true">
                      <td colspan="11" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="(data,index) in dataProduct" :key="index" v-else>
                      <td>{{ data.productId }}</td>
                      <td>{{ data.brand }}</td>
                      <td>{{ data.productTitle}}</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="toDetailPage('id', 'ticket')"> Detail </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-between mt-3">
                  <div class="d-flex align-items-center">
                    <div style="margin-right: 10px;">
                      <select class="form-control form-control-sm" v-model="itemPerPage" @change="showPage()">
                              <option value="10">10</option>
                              <option value="40">40</option>
                              <option value="80">80</option>
                      </select>
                    </div>
                    <div class="total-data align-self-center">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div>
                    <div class="pagination p8">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <div class="modal fade" id="modalAdd" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Add In</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-center">
                <span class="label-text-field">Source</span>
                <multiselect v-model="searchSparepartType" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
              </div>
              <div class="d-flex mt-2 align-items-center">
                <span class="label-text-field-two">Unique ID</span>
                <input type="text" class="form-control text-field" name="sparepartName" v-model="sparepartNameAdd" placeholder="SKU / SC / SN / LP">
                <button class="btn btn-primary ml-2">Get</button>
              </div>
              <hr>
              <table class="add-in">
                <tr>
                  <td style="width: 115px;" valign="top">Source</td>
                  <td style="width: 10px;" valign="top">:</td>
                  <td></td>
                </tr>
                <!-- Return  -->
                <tr>
                  <td valign="top">Lessee</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <!-- Return -->
                <tr>
                  <td valign="top">SKU</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Name</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <!-- Return -->
                <tr>
                  <td valign="top">Serial Number</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Product Code</td>
                  <td>:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Stock Code</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Specification</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Return Status</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Return Note</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <!-- Return -->
                <tr>
                  <td>Qty</td>
                  <td>:</td>
                  <td>
                    <input type="number" name="qty" class="form-control">
                  </td>
                </tr>
                <!-- Procure -->
                <tr>
                  <td valign="top">Procure PIC</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <tr>
                  <td valign="top">Courier PIC</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <!-- Procure -->
                <!-- stock opname -->
                <tr>
                  <td>Condition</td>
                  <td>:</td>
                  <td>
                    <multiselect v-model="searchSparepartType" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
                  </td>
                </tr>
                <!-- stock opname -->
                <!-- My BAG -->
                <tr>
                  <td valign="top">Support PIC</td>
                  <td valign="top">:</td>
                  <td></td>
                </tr>
                <!-- My Bag -->
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success btn-sm">More Add In</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAdd">Done</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Done</button>

            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalEdit" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Edit Sparepart</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-center">
                <span class="label-text-field">Type</span>
                <multiselect v-model="searchSparepartType" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory" disabled></multiselect>
              </div>
              <div class="d-flex mt-2 align-items-center">
                <span class="label-text-field">Name</span>
                <input type="text" class="form-control" name="sparepartName" v-model="sparepartNameAdd">
              </div>
              <div class="text-center mt-2"><i class=""></i> This change will have impact on warehouse stock</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitEdit">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Save</button>

            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalLog" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-xl">
              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header">
                      <div class="change-title">
                          <h4 class="modal-title">Catalog Sparepart Log</h4>
                      </div>
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="modal-body">
                      <table class="table table-sm table-bordered table-striped table-responsive-sm">
                        <thead class="">
                          <tr>
                            <th>Date</th>
                            <th>Action</th>
                            <th>Executor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="loadingTable === false && totalData == '0'">
                            <td colspan="7" class="text-center">Data Not Available</td>
                          </tr>
                          <tr v-else-if="loadingTable === true">
                            <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                          </tr>
                          <tr v-for="(data,index) in dataProduct" :key="index" v-else>
                            <td>{{ data.productId }}</td>
                            <td>{{ data.brand }}</td>
                            <td>{{ data.productTitle}}</td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'ProductPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
      admin:"",
      adminId:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      dataProduct: [],
      dataSearchProduct: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      orderId:"",
      companyName:"",
      statusOrder:"",
      loadingTable:true,
      productBrand:[],
      productBrandSearch:[],
      productSpec:[],
      productIdChoose:'',
      productNameChoose:'',
      statusChoose:'',
      showingChoose:'',
      allShowing:[],
      searchBrand:'All',
      search:false,
      searchCategory:{
        productCategory:'All'
      },
      productCategory:[],
      searchType:{
        productType:'All',
        productTypeName:'All'
      },
      productType:[],
      brandSelect:[],
      searchProductName:'',
      searchStatus:{
          status:'All',
          statusName:'All'
      },
      productStatusSelect:[
      {
         status:'All',
         statusName:'All' 
      },
      {
         status:'1',
         statusName:'Active' 
      },
      {
         status:'0',
         statusName:'Inactive' 
      },
      ],
      searchSku:'',
      searchSparepartName:'',
      searchProductName:'',
      searchSparepartType:'',
      sparepartNameAdd:'',
      itemPerPage:10
    }
  },
  methods: {
    toDetailPage(id, purpose){
      this.$router.push({path:'/orderlist/detail/'+id, query: {
              purpose: purpose,
              page:1,
              itemPerPage:10
          }
      })
    },
    submitDelete(){

    },
    submitEdit(){

    },
    submitAdd(){

    },
    resetSearch(){

    },
    openModal(modalName) {
      $("#modal"+modalName).modal('show')
    },
    searchData(){
      let productType = ''
      let productTypeName = ''
      let productCategory = ''
      if (this.searchType != null) {
          if (this.searchType.length != 0) {
              productType = this.searchType.productType
              productTypeName = this.searchType.productTypeName
          }
      }
      if (this.searchCategory != null) {
          if (this.searchCategory.length != 0) {
              productCategory = this.searchCategory.productCategory
          }
      }
      if (this.searchBrand == null) {
          this.searchBrand = ''
      }
      this.$router.push({path:'/product/top', query: {
              productType: productType,
              productTypeName: productTypeName,
              productCategory: productCategory,
              productBrand: this.searchBrand,
              productStatus: this.searchStatus.status,
              productStatusName: this.searchStatus.statusName,
              productName: this.searchProductName,
              page:1
          }
      })
      this.getData();
    },
    toDataPage(pagePost){
      this.loadingTable = true
      let productType = ''
      let productTypeName = ''
      let productCategory = ''
      if (this.searchType != null) {
          if (this.searchType.length != 0) {
              productType = this.searchType.productType
              productTypeName = this.searchType.productTypeName
          }
      }
      if (this.searchCategory != null) {
          if (this.searchCategory.length != 0) {
              productCategory = this.searchCategory.productCategory
          }
      }
      if (this.searchBrand == null) {
          this.searchBrand = ''
      }
      this.$router.push({path:'/product/top', query: {
              productType: productType,
              productTypeName: productTypeName,
              productCategory: productCategory,
              productBrand: this.searchBrand,
              productStatus: this.searchStatus.status,
              productStatusName: this.searchStatus.statusName,
              productName: this.searchProductName,
              page:1
          }
      })
      this.getData();
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
      }
      if (this.viewProduct == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    getData(){
      this.loadingTable = true
      if (this.$route.query.productType != '') {
          this.searchType = {
              productType: this.$route.query.productType,
              productTypeName: this.$route.query.productTypeName
          }
      } else {
          this.searchType = null
      }
      if (this.$route.query.productCategory != '') {
          this.searchCategory = {
              productCategory: this.$route.query.productCategory
          }
      }
      if (this.$route.query.productStatus != '') {
          this.searchStatus = {
              status: this.$route.query.productStatus,
              statusName: this.$route.query.productStatusName
          }
      } else {
          this.searchStatus = null
      }
      this.searchBrand = this.$route.query.productBrand
      this.searchProductName = this.$route.query.productName
      this.currentPage = parseInt(this.$route.query.page)
      this.$http.post(process.env.SEARCH_TOP_PRODUCT,{
        productType: this.$route.query.productType,
        productCategory: this.$route.query.productCategory,
        productBrand: this.searchBrand !== null ? this.searchBrand.replace(this.spaceRegex, ' ') : this.searchBrand,
        productStatus: this.$route.query.productStatus,
        productName: this.searchProductName !== null ? this.searchProductName.replace(this.spaceRegex, ' ') : this.searchProductName,
        page:1
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
              // this.handleLogout()
            }else{
              this.dataProduct = response.data.content.data
              this.productBrand = []
              this.productSpec = []
              this.totalPage = response.data.content.totalPage
              this.currentPage = response.data.content.currentPage
              this.totalData = response.data.content.totalData
              this.allShowing = response.data.content.allShowing
              this.loadingTable = false
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })

      this.$http.get(process.env.GET_CATEGORY,{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
              // this.handleLogout()
            }else{
              this.productType.push({
                productType:'All',
                productTypeName:'All',
              })
              for (var i = 0; i < response.data.content.productType.length; i++) {
                this.productType.push({
                    productType:response.data.content.productType[i].productType,
                    productTypeName: response.data.content.productType[i].productTypeName
                })
              }
              this.productCategory.push({
                productCategory:'All'
              })
              for (var i = 0; i < response.data.content.productCategory.length; i++) {
                this.productCategory.push({
                    productCategory:response.data.content.productCategory[i].productCategory
                })
              }
              this.brandSelect = ['All']
              for (var i = 0; i < Object.values(response.data.content.productBrand).length; i++) {
                this.brandSelect.push(Object.values(response.data.content.productBrand)[i]
                )
              }
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    sendLog(x,y){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'
        var productName = this.productNameChoose.replace(this.spaceRegex, ' ')
        if (y == '35') {
            var newShowing = this.showingChoose
            this.$http.post(process.env.LOG_URL+"/product/"+x,{
                codeLogs: y,
                params: [productName, newShowing],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
            })
        }else{
            this.$http.post(process.env.LOG_URL+"/product/"+x,{
                codeLogs: y,
                params: [productName],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
            })
        }
    }
  },
  created(){
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  table.add-in tr td{
    height: 42.2px;
  }
  .text-field{
    height: 42.2px;
  }
  .label-text-field{
    width: 100px;
  }
  .label-text-field-two{
    width: 121px;
  }

  .pagination{
    padding: 0px 0;
  }

  .pagination ul{
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .pagination a{
    display: inline-block;
    padding: 1px 6px;
    color: #222;
  }

  .p8 a{
    background-color: #2797FB;
    color: #fff;
    border: 1px solid #2797FB;
  }

  .p8 a:hover{
    text-decoration: none;
  }
  .p8 a.page:hover{
    text-decoration: none;
    color: #fff;
  }

  .p8 .is-active{
    background-color: #fff;
    color: #2797FB;
  }

  .total-data{
    font-size: 14px;
    color: #343A40;
  }
</style>



// WEBPACK FOOTER //
// src/components/Warehouse/OrderListPage.vue